// extracted by mini-css-extract-plugin
export default {"container":"container-FzmYu","button":"button-K3o4i","on":"on-vgpeK","label":"label-FbxaP"};